import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import zhTranslation from "./locales/zh/translation.json";
import zhHKTranslation from "./locales/zh-HK/translation.json";
import zhTWTranslation from "./locales/zh-TW/translation.json";
import jaTranslation from "./locales/ja/translation.json";

const resources = {
  en: {
    translation: enTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
  "zh-HK": {
    translation: zhHKTranslation,
  },
  "zh-TW": {
    translation: zhTWTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
};

i18n
  .use(LanguageDetector) // 检测用户语言
  .use(initReactI18next) // 将 i18n 集成到 React 中
  .init({
    resources,
    fallbackLng: "en", // 默认语言
    detection: {
      order: ["localStorage", "cookie", "navigator"], // 检测顺序
      caches: ["localStorage", "cookie"], // 保存用户语言的地方
    },
    interpolation: {
      escapeValue: false, // React 已经对字符串进行防止 XSS 处理
    },
  });

export default i18n;
